import {CopyToClipboardIconButton} from '@github-ui/copy-to-clipboard/IconButton'
import {clsx} from 'clsx'

import styles from './VerifyAttestation.module.css'

export function VerifyAttestation({url}: {url: string}) {
  return (
    <div className={clsx('d-flex mb-2', styles.Box)}>
      <label htmlFor="verify-attestation-with-gh" className="sr-only">
        verify-attestation-with-gh
      </label>
      <textarea
        id="verify-attestation-with-gh"
        className="form-control input-monospace input-sm color-bg-subtle"
        data-autoselect
        value={url}
        readOnly
        rows={1}
        style={{flexGrow: 1, resize: 'vertical'}}
      />
      <CopyToClipboardIconButton
        className={clsx('ml-1 mr-0', styles.CopyToClipboardIconButton)}
        textToCopy={url}
        ariaLabel="Verify attestation"
        tooltipProps={{direction: 'nw'}}
      />
    </div>
  )
}
